import { createSelector, createSlice } from '@reduxjs/toolkit';
import { RootState } from 'app/store';
import { InvoiceInfoSliceInitialState } from './invoiceInfoTypes';
import {
  getLatestInvoiceBySubscriptionId,
  payLatestInvoiceBySubscriptionId
} from './invoiceInfoActions';
import {
  isFulfilledAction,
  isPendingAction,
  isRejectedAction,
} from '../../sliceHelpers';

const initialState: InvoiceInfoSliceInitialState = {
  invoiceInfo: null,
  isLoading: false,
};

export const invoiceInfoSlice = createSlice({
  name: '@@invoiceInfo',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getLatestInvoiceBySubscriptionId.fulfilled, (state, action) => {
      state.invoiceInfo = action.payload;
    });
    builder.addCase(payLatestInvoiceBySubscriptionId.fulfilled, (state, action) => {
      state.invoiceInfo = action.payload;
    });
    builder.addMatcher(isPendingAction, (state) => {
      state.isLoading = true;
    });
    builder.addMatcher(isFulfilledAction, (state) => {
      state.isLoading = false;
    });
    builder.addMatcher(isRejectedAction, (state) => {
      state.isLoading = false;
    });
  },
});

export const invoiceInfoSelector = createSelector(
  [(state: RootState) => state.invoiceInfo],
  (info) => info
);
